import React, { useEffect, useState } from 'react';

const BANNER_HEIGHT = 26;

const ContourBanner: React.FC = () => {
  const [isTest, setIsTest] = useState(false);

  useEffect(() => {
    let cancelled = false;
    fetch('/api/health')
      .then((r) => (r.ok ? r.json() : null))
      .then((data) => {
        if (!cancelled && data?.contour === 'test') {
          setIsTest(true);
        }
      })
      .catch(() => undefined);
    return () => {
      cancelled = true;
    };
  }, []);

  useEffect(() => {
    if (!isTest) return undefined;
    const prevPadding = document.body.style.paddingTop;
    const prevTitle = document.title;
    document.body.style.paddingTop = `${BANNER_HEIGHT}px`;
    if (!document.title.startsWith('ТЕСТ — ')) {
      document.title = `ТЕСТ — ${document.title}`;
    }
    return () => {
      document.body.style.paddingTop = prevPadding;
      document.title = prevTitle;
    };
  }, [isTest]);

  if (!isTest) return null;

  return (
    <div
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        height: BANNER_HEIGHT,
        zIndex: 999,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        background:
          'repeating-linear-gradient(45deg, #d4380d, #d4380d 16px, #fa8c16 16px, #fa8c16 32px)',
        color: '#fff',
        fontWeight: 700,
        fontSize: 13,
        letterSpacing: 1,
        textShadow: '0 1px 2px rgba(0,0,0,0.5)',
        userSelect: 'none',
      }}
    >
      ТЕСТОВАЯ ВЕРСИЯ — данные не боевые
    </div>
  );
};

export default ContourBanner;
